module.exports = "/images/Create your submittal log - 6.jpg";